module.exports = __webpack_public_path__ + "img/hpp-icon.84fb314a.png";